export default "__VITE_ASSET__CFJOf_p4__"